// @ts-nocheck
import React from "react"
import styled from "styled-components"
import { Styles } from "../config"

const getIconSize = ({ size }) => {
	if (size) return Styles.IconSize[size]
	else return Styles.IconSize.medium
}

const variants = { outline: "-outlined" }

const I = styled.i`
	max-width: ${(props) => props?.style?.width || getIconSize({ size: props.size })};
	min-width: ${(props) => props?.style?.width || getIconSize({ size: props.size })};
	max-height: ${(props) => props?.style?.height || getIconSize({ size: props.size })};
	min-height: ${(props) => props?.style?.height || getIconSize({ size: props.size })};
	margin: ${(props) => (props.margin ? props.margin : 0)};
	vertical-align: middle;
	font-size: ${(props) => (props.size ? Styles.IconSize[props.size] : Styles.IconSize["small"])};

	color: ${(props) => {
		if (props?.style?.color) return props?.style?.color
		else return props.color ? Styles.Color[props.color] : Styles.Color.primary
	}};
`

export default function Icon(props) {
	let { name, provider, variant } = props

	const outlinedRegex = /_outlined$/
	if (outlinedRegex.test(name)) variant = "outline"

	let className = `material-icons`
	if (variant) className = `material-icons${variants[variant]}`
	if (provider) className = provider

	return (
		<I {...props} className={className}>
			{name.replace("_outlined", "")}
		</I>
	)
}
